import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback } from "react";
import { useIndueCardCreateCardMutation } from "generated/generated-models";
import { useNavigate } from "react-router";
import { pdfjs, Document, Page } from "react-pdf";
import Title from "app/components/Title";
import { Formik } from "formik";
import Form from "app/components/Form";
import RequestMultiFactorTokenFormik from "app/components/RequestMultiFactorTokenFormik";
import { nameof } from "core/util/nameof";
import { Validate, } from "./IndueCardConfirmCreateCardValidate";
import { Alert, Button, Tooltip } from "@mui/material";
import { GetAssetUri } from "core/util/pathsHelper";
pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();
const IndueCardConfirmCreateCardPage = ({ accountId, }) => {
    const [acceptedTerms, setAcceptedTerms] = useState();
    const [readTerms, setReadTerms] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [currentMFAStatus, setCurrentMFAStatus] = useState("WithoutMFA");
    const [createCard, { data, error }] = useIndueCardCreateCardMutation();
    const [numPages, setNumPages] = useState();
    const pdfDocument = useCallback((element) => {
        if (element == null) {
            return;
        }
        element.onscroll = () => {
            // Get how close the user is to scrolling to the bottom of the page
            const difference = element.scrollHeight - element.scrollTop - element.clientHeight;
            // Use an epsilon cause floating point numbers are sad
            const bottom = Math.abs(difference) < 10;
            if (bottom) {
                setReadTerms(true);
            }
        };
    }, []);
    const url = GetAssetUri("/client/misc/cardTermsAndConditions.pdf");
    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };
    const initialValues = {
        accountId: accountId,
    };
    const handleRequiresMFA = () => {
        setCurrentMFAStatus("WithMFA");
    };
    const handleUserAcceptsTerms = async (values) => {
        try {
            setSubmitting(true);
            const result = await createCard({
                variables: {
                    input: {
                        AccountId: accountId,
                        TwoFactorToken: values.twoFactorToken,
                    },
                },
            });
            if (result.data?.createCard?.Code === "499") {
                handleRequiresMFA();
            }
            if (result.data?.createCard?.Success === true) {
                setAcceptedTerms(true);
            }
        }
        catch (ex) {
            console.error("Could not order card.");
        }
        finally {
            setSubmitting(false);
        }
    };
    const navigate = useNavigate();
    if (acceptedTerms === false) {
        navigate(-1);
    }
    if (acceptedTerms === true) {
        navigate(-1);
    }
    return (_jsxs("div", { className: "container sub-wrap card-terms-page", children: [_jsx(Title, { title: "Terms and Conditions" }), _jsx("div", { className: "card-terms-container", children: _jsx("div", { className: "card-terms-document-container", children: _jsx(Document, { file: url, onLoadSuccess: onDocumentLoadSuccess, className: "card-terms-document", inputRef: pdfDocument, loading: "Loading Terms and Conditions", children: Array.from(new Array(numPages), (_el, index) => (_jsx(Page, { pageNumber: index + 1, scale: 1.5, className: "card-terms-page", loading: "", renderTextLayer: false }, `page_${index + 1}`))) }) }) }), _jsx(Formik, { initialValues: initialValues, onSubmit: (values) => handleUserAcceptsTerms(values), validationSchema: () => Validate(currentMFAStatus === "WithMFA"), children: ({ isSubmitting }) => {
                    return (_jsx("div", { className: "firsttimelogin-tc-button-container", children: _jsxs(Form, { children: [_jsxs("div", { className: "sub-wrap form-wrap", children: [data?.createCard?.Message != null && (_jsx(Alert, { severity: "error", children: data?.createCard.Message })), currentMFAStatus === "WithMFA" && (_jsx("div", { children: _jsx(RequestMultiFactorTokenFormik, { name: nameof("twoFactorToken"), showRequestNewToken: true, requestMfaOnDisplay: true }) })), error != null && (_jsx(Alert, { severity: "error", style: { marginTop: "0.5rem" }, children: "Could not order a card at this time. Please try again later or contact customer service." }))] }), _jsx(Button, { variant: "contained", role: "secondary", disabled: isSubmitting, id: "cancel", className: "btn-cancel", onClick: () => setAcceptedTerms(false), children: "Cancel" }), _jsx(Tooltip, { title: "Please read to the end of the Terms and Conditions", disableHoverListener: readTerms, children: _jsx("div", { className: "d-inline-block float-right", children: _jsx(Button, { variant: "contained", style: {
                                                pointerEvents: readTerms
                                                    ? "auto"
                                                    : "none",
                                            }, type: "submit", id: "submit", disabled: !readTerms || submitting, children: "Accept Terms" }) }) })] }) }));
                } })] }));
};
export default IndueCardConfirmCreateCardPage;
